import { signinRedirect as sr } from 'shared/services/userService';
import { applicationState, SignedInState } from 'shared/store/applicationState'

export const signinRedirect = sr;

export async function getToken() {
    let user = await getUser();
    return user.access_token;
}

// Wait period and retries only relates to loading the user from local storage
// Unrelated to getting user from the network or other network API requrests
const retryWaitPeriod = 100;
const maxRetries = 9;

// Do not return until we have a valid user or have retried the maximum amount
// Returning right away without a valid user and token will cause any request sent to the server to fail
// Letting exceptions go uncaught should prevent unnecessary network requests being sent by consumers of getToken()
async function getUser() {
    await waitForUserLoad();
    let user = applicationState.getUser();

    var retry = 1;
    while (typeof (user?.access_token) !== "string") {
        retry++;
        await blockWait(retryWaitPeriod);
        user = applicationState.getUser();
        if (retry > maxRetries) {
            throw new Error("Timeout waiting for user access token");
        }
    }

    return user;
}

// Waiting is typically only needed when the application has first loaded
// Without waiting there are intermittent race conditions where requests may be sent before the user has loaded resulting in 401 responses
export async function waitForUserLoad() {
    let state = applicationState.getSignedInState();
    let retry = 0;

    while (state == undefined || state == SignedInState.Loading) {
        retry++;
        await blockWait(retryWaitPeriod);
        state = applicationState.getSignedInState();
        if (retry > maxRetries) {
            throw new Error("Timeout waiting for expected user loading state");
        }
    }
}

function blockWait(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
